(function () {
	'use strict';
	angular.module('app.setup')
        .controller('dataPipelineHistory', dataPipelineHistory);
        
	dataPipelineHistory.$inject = ['$rootScope', '$scope', '$location', '$timeout', '$experiments', 'columnsService', 'leanFilterService', 'tableService'];

	function dataPipelineHistory($rootScope, $scope, $location, $timeout, $experiments, columnsService, leanFilterService, tableService) {
    
		var vm = this;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.factoryNdx = $location.search().factoryNdx;
		vm.linkBackUrl = '/application/f/home.html#/setup/data-pipeline';
		vm.linkBackText = 'Data Sync Status';
		vm.reportName = 'History for Site ' + vm.factoryNdx;
		vm.hideFavorite = true;
		vm.useReactReport = $experiments.isEnabled('react-data-sync');

		init();

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams)
				.then(function(response) {
					// Clean up newline at end of instanceIds
					for(var i=0; i<response[0].data.length; i++) {
						if(response[0].data[i].instanceId) {
							response[0].data[i].instanceId = response[0].data[i].instanceId.trim();
						}
					}
					if(response[0].data[0]) {
						// Replace the page header's factoryNdx with name if available
						vm.reportName = 'History for ' + response[0].data[0].factory;
					}
					return response;
				})
				.catch(function(response) {
					$rootScope.$emit('toast', {
						'message': 'An error occurred while retrieving data.',
						'success': false
					});
					return [response.data];
				});
		}

		function init() {
			leanFilterService.clearFilters();

			leanFilterService.setMasterFilterList([
				leanFilterService.filterDefinitions['WorkerType'],
				leanFilterService.filterDefinitions['WorkerState']
			]);

			leanFilterService.setMasterRangeFilterList([
				leanFilterService.filterDefinitions['DateRequested'],
				leanFilterService.filterDefinitions['DateStarted'],
				leanFilterService.filterDefinitions['DateEnded']
			]);
		}

		var columns = columnsService({
			factory: 0,
			type: 1,
			action: 1,
			status: 1,
			statusDetail: 1,
			statusDetailInternal: 1, // note that the column in data-pipeline-columns.service.js has a conditional based on leandna admin
			instanceId: 0,
			dateRequest: 1,
			waitTime: 1,
			dateStart: 1,
			runTime: 1,
			dateEnd: 1,
			requestor: 0
		});

		var meta = {
			noPaging: false,
			pageSize: 50,
			doCount: false,
			reportUrl: vm.factoryNdx + '/WorkerQueue/History',
			columns: columns,
			defaultSort: 'dateRequest',
			defaultSortDirection: 'desc',
			defaultFilters: [],
			pinnedColumns: [],
			reportSettingsName: 'DataPipelineHistory',
			hideSearch: true,
			extraParams: [{excelReportName: 'DataPipelineHistory'}],
			rendererParams: {},
			setColumnDefaults: true,
			isGlobalReportSetting: true
		};
	}
})();
